export const MenuXIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <g clipPath="url(#clip0_2668_9073)">
        <path d="M0.754822 9.20215L8.71454 1.28798L9.24514 0.760088" stroke="#080808" />
        <path d="M0.754821 0.810981L9.24515 9.2373" stroke="#080808" />
      </g>
      <defs>
        <clipPath id="clip0_2668_9073">
          <rect width="10" height="10" fill="white" transform="translate(0 10) rotate(-90)" />
        </clipPath>
      </defs>
    </svg>
  );
};
